// utils/size-guide-path.ts
export const SIZE_GUIDE_IMAGES = {
  'men-daura-surwal': [
    '/size-guide/men-daura-surwal/men-daura-surwal-size-guide-1.png',
    '/size-guide/men-daura-surwal/men-daura-surwal-size-guide-2.png',
  ],
  'men-kurta': [
    '/size-guide/men-kurta/men-kurta-size-guide-1.png',
    '/size-guide/men-kurta/men-kurta-size-guide-2.png',
    '/size-guide/men-kurta/men-kurta-size-guide-3.png',
  ],
  'men-kurta-and-sherwani': [
    '/size-guide/men-kurta-and-sherwani/men-kurta-and-sherwani-size-guide-1.png',
    '/size-guide/men-kurta-and-sherwani/men-kurta-and-sherwani-size-guide-2.png',
    '/size-guide/men-kurta-and-sherwani/men-kurta-and-sherwani-size-guide-3.png',
  ],
  'men-suit': [
    '/size-guide/men-suit/men-suit-size-guide-1.png',
    '/size-guide/men-suit/men-suit-size-guide-2.png',
    '/size-guide/men-suit/men-suit-size-guide-3.png',
  ],
  'women-dress-and-gown': [
    '/size-guide/women-dress-and-gown/women-dress-and-gown-size-guide-1.png',
  ],
  'women-kurta': [
    '/size-guide/women-kurta/kurta-size-guide-1.png',
    '/size-guide/women-kurta/kurta-size-guide-2.png',
    '/size-guide/women-kurta/kurta-size-guide-3.png',
  ],
  'women-lehenga': ['/size-guide/women-lehenga/women-lehenga-size-guide-1.png'],
  'women-saree': [],
} as const;
